import { Component } from '@verndale/core';
import { triggerCustomEvent } from '../utils/events';

const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
const phonePattern = /^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/;

const validatePattern = (value, pattern) => pattern.test(value);
const validateRequired = (value) => value.trim().length > 0;
const validatePhone = (value) =>
  value.trim().length > 9 && validatePattern(value, phonePattern);

class FieldValidator extends Component {
  setupDefaults() {
    this.dom = {
      $input: this.el._$('.field__input'),
      $errorMessage: this.el._$('.field__error-msg')
    };

    this.isRequired = this.dom.$input.hasAttribute('required');
    this.isEmail = this.dom.$input.getAttribute('type') === 'email';
    this.isPhone = this.dom.$input.getAttribute('type') === 'phone';
    this.errorRequired = this.el.dataset.errorRequired || '';
    this.errorEmail = this.el.dataset.errorEmail || '';
    this.errorPhone = this.el.dataset.errorPhone || '';

    this.addValidators();
    this.handleInputChange();
  }

  addListeners() {
    const { $input } = this.dom;

    $input._on('change', ::this.handleInputChange);
    $input._on('keyup', ::this.handleInputChange);
    $input._on('blur', ::this.handleInputChange);
  }

  addValidators() {
    const { $input } = this.dom;
    this.validators = [];
    this.errors = [];

    if (this.isRequired) {
      this.validators.push(() => validateRequired($input.value));
      this.errors.push(this.errorRequired);
    }

    if (this.isEmail) {
      this.validators.push(() => validatePattern($input.value, emailPattern));
      this.errors.push(this.errorEmail);
    }

    if (this.isPhone) {
      this.validators.push(() => validatePhone($input.value));
      this.errors.push(this.errorPhone);
    }
  }

  validate(showErrors = true) {
    const { $input, $errorMessage } = this.dom;
    const isTouched = this.el.classList.contains('field--touched');
    let isValid = true;

    if (!this.isRequired && !$input.value) {
      this.el.classList.remove('field--ok');
      this.el.classList.remove('field--error');

      return true;
    }

    if (
      this.validators.length &&
      this.errors.length &&
      this.validators.some((validator) => !validator())
    ) {
      if (showErrors || isTouched) {
        this.el.classList.add('field--error');
        this.el.classList.remove('field--ok');
        $errorMessage.textContent = this.errors[
          this.validators.findIndex((validator) => !validator())
        ];
      }
      isValid = false;
    } else {
      if (showErrors || isTouched) {
        this.el.classList.add('field--ok');
        this.el.classList.remove('field--error');
      }
    }

    return isValid;
  }

  reset() {
    const { $input } = this.dom;

    this.el.classList.remove('field--ok');
    this.el.classList.remove('field--error');
    this.el.classList.remove('field--filled');
    $input.value = '';
    triggerCustomEvent($input, 'reset', { bubbles: true });
  }

  handleInputChange() {
    this.validate();
  }
}

export default FieldValidator;
